<div class="error_container">
  <div>Icon Goes Here...</div>
  >
  <h2 class="error_message">YOU HAVE SUCCESSFULLY LOGGED OUT OF CLEANFILL!</h2>
  <h2 class="error_number">Click Here To Login!</h2>
  <button class="button_main_white" routerLink="/"><i class="material-icons">power_settings_new</i>LOGIN</button>
</div>
